/*
 * Map scroll-trap guard.
 *
 * The map section covers its iframe with a transparent label bound to a
 * checkbox, so wheel and touch gestures move the page instead of zooming the
 * map. Checking the box hides the overlay and hands gestures to the map -- that
 * part is pure CSS and works without this file.
 *
 * All this script adds is re-arming: once the pointer leaves the map, or the
 * visitor interacts elsewhere on the page, the overlay comes back so the next
 * scroll over the map does not get swallowed again.
 */
(function () {
  'use strict';

  function sections() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-map-section]'));
  }

  function disarm(section) {
    var toggle = section.querySelector('[data-map-activate]');
    if (toggle && toggle.checked) toggle.checked = false;
  }

  function bind(section) {
    if (section.dataset.mapGuardBound === 'true') return;
    section.dataset.mapGuardBound = 'true';

    // Desktop: leaving the map re-arms the overlay. Bound to the map frame
    // rather than the whole section, so moving from the map onto the address
    // cards beside it already re-arms.
    var frame = section.querySelector('.map__frame') || section;
    frame.addEventListener('mouseleave', function () {
      disarm(section);
    });

    // Touch: there is no mouseleave, so re-arm when the visitor touches
    // anything outside this section.
    document.addEventListener(
      'touchstart',
      function (event) {
        if (!section.contains(event.target)) disarm(section);
      },
      { passive: true }
    );
  }

  function init() {
    sections().forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Theme editor re-renders the section, which drops the listeners.
  document.addEventListener('shopify:section:load', function (event) {
    var target = event.target;
    if (!target || !target.querySelectorAll) return;
    Array.prototype.slice.call(target.querySelectorAll('[data-map-section]')).forEach(function (section) {
      delete section.dataset.mapGuardBound;
      bind(section);
    });
  });
})();
